import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/layout/Navigation';
import CriminalImg from '../assets/images/criminallaw.jpg'

const CriminalLawService = () => {
    return (
        <div className="font-sans">
        <Navigation />
        
        {/* Breadcrumb */}
        <div className="container mx-auto px-4 py-4 mt-16 text-center md:text-left">
            <div className="text-gray-500">
            <Link to="/" className="hover:text-red-600">Home</Link> {' > '}
            <Link to="/practice-areas" className="hover:text-red-600">Practice Area</Link> {' > '}
            <span className="text-red-600">Criminal Law</span>
            </div>
        </div>
        
        {/* Title */}
        <div className="container mx-auto px-4 pb-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Criminal Law</h1>
        </div>
        
        {/* Banner Image */}
        <div className="container mx-auto px-4 mb-12">
            <div className="relative rounded-lg overflow-hidden">
            <img 
                src={CriminalImg} 
                alt="Criminal law - scales of justice and gavel" 
                className="w-full object-cover h-[400px]"
            />
            </div>
        </div>
        
        {/* Content Section */}
        <div className="container mx-auto px-4 py-8">
            <div className="max-w-4xl mx-auto space-y-8">
            <div className="space-y-6 text-gray-700 text-lg">
                <p>
                When facing criminal charges in Islamabad or Rawalpindi, having a skilled and knowledgeable criminal defense lawyer 
                can make all the difference in the outcome of your case. Wisdoms Law provides 
                expert criminal defense representation throughout the twin cities.
                </p>
                
                <p>
                Our criminal law team has extensive experience navigating the complex criminal justice system in Islamabad and Rawalpindi, 
                from handling cases at the investigation stage to representing clients in trials before Magistrates, 
                Sessions Courts, and appellate proceedings before the Islamabad High Court.
                </p>
                
                <p>
                We understand that being accused of a crime can be a frightening experience. Our approach combines 
                aggressive defense strategies with compassionate client service. We work tirelessly to protect your 
                rights, preserve your freedom, and achieve the best possible outcome in your case.
                </p>
                
                <p>
                Whether you're facing minor offenses or serious criminal charges under the Pakistan Penal Code, 
                our dedicated team of criminal defense attorneys at Wisdoms Law is prepared to stand by your side and fight 
                for your rights at every stage of the criminal process.
                </p>
            </div>
            
            <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Criminal Law Services Include:</h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-red-700 mb-3">Criminal Defense</h3>
                    <p className="text-gray-600">
                    Strong defense against all types of criminal charges under the Pakistan Penal Code in Islamabad and Rawalpindi courts, 
                    from theft and assault to more serious offenses such as murder and terrorism-related charges.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-red-700 mb-3">Bail Applications</h3>
                    <p className="text-gray-600">
                    Expert handling of pre-arrest bail, post-arrest bail, and protective bail applications at all court levels in Islamabad and Rawalpindi, 
                    with emergency assistance available when needed.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-red-700 mb-3">FIR Challenges</h3>
                    <p className="text-gray-600">
                    Assistance with challenging false or incorrectly filed First Information Reports (FIRs) at police stations throughout Islamabad and Rawalpindi, 
                    including quashment proceedings and proper FIR registration when you are a victim.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-red-700 mb-3">Criminal Appeals</h3>
                    <p className="text-gray-600">
                    Representation in criminal appeals before Sessions Courts and the Islamabad High Court, 
                    challenging convictions and excessive sentences obtained in lower courts.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-red-700 mb-3">White Collar Crimes</h3>
                    <p className="text-gray-600">
                    Defense against charges including fraud, embezzlement, money laundering, tax evasion, 
                    and corruption, including cases before NAB (National Accountability Bureau) Rawalpindi.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-red-700 mb-3">Cyber Crimes</h3>
                    <p className="text-gray-600">
                    Legal representation in cases under the Prevention of Electronic Crimes Act (PECA) before the FIA Cyber Crime Wing in Islamabad, 
                    defending against allegations of online harassment, hacking, data theft, and other cybercrimes.
                    </p>
                </div>
                </div>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">The Wisdoms Law Criminal Defense Advantage</h2>
                
                <ul className="space-y-4 mt-4">
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-red-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Deep Experience with Islamabad & Rawalpindi Courts:</strong> Our attorneys have handled thousands of criminal cases throughout the twin cities' legal system.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-red-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Strategic Defense Planning:</strong> We conduct thorough case evaluations to develop strong defense strategies tailored to your specific situation.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-red-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Constitutional Rights Protection:</strong> We vigilantly protect your fundamental rights guaranteed under the Constitution of Pakistan.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-red-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">24/7 Availability:</strong> Criminal matters often require immediate attention - our team is available around the clock for emergency situations in Islamabad and Rawalpindi.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-red-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Local Court Relationships:</strong> Our established relationships with prosecutors, judges, and court personnel throughout Islamabad and Rawalpindi legal system benefit our clients.
                    </span>
                </li>
                </ul>
            </div>
            
            {/* Recent Case Results */}
            <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Recent Case Results</h2>
                
                <div className="space-y-4 mt-6">
                <div className="border-l-4 border-red-600 pl-4 py-3">
                    <h3 className="font-bold text-lg">Murder Charge Acquittal</h3>
                    <p className="text-gray-600">Successfully secured a complete acquittal for a client facing murder charges in Rawalpindi Sessions Court by demonstrating inconsistencies in witness testimony and procedural irregularities.</p>
                </div>
                
                <div className="border-l-4 border-red-600 pl-4 py-3">
                    <h3 className="font-bold text-lg">NAB Case Dismissed</h3>
                    <p className="text-gray-600">Obtained dismissal of corruption charges brought by the National Accountability Bureau against a government official at NAB Rawalpindi by proving lack of evidence and procedural violations.</p>
                </div>
                
                <div className="border-l-4 border-red-600 pl-4 py-3">
                    <h3 className="font-bold text-lg">Cybercrime Defense Success</h3>
                    <p className="text-gray-600">Successfully defended a client against serious cybercrime allegations under PECA before the FIA Cyber Crime Wing in Islamabad, resulting in all charges being withdrawn due to our effective legal strategy.</p>
                </div>
                </div>
            </div>
            
            {/* CTA Section */}
            <div className="bg-red-50 p-8 rounded-lg border border-red-100 text-center">
                <h2 className="text-2xl font-bold text-red-800 mb-4">Facing Criminal Charges in Islamabad or Rawalpindi?</h2>
                <p className="text-red-600 mb-6">
                Don't wait to secure legal representation. Contact Wisdoms Law immediately for a confidential consultation.
                </p>
                <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link 
                    to="/contact" 
                    className="bg-red-600 text-white px-6 py-3 rounded-md font-medium hover:bg-red-700 transition-colors"
                >
                    Request Urgent Consultation
                </Link>
                <a 
                    href="tel:+923001234567" 
                    className="bg-white text-red-600 border border-red-600 px-6 py-3 rounded-md font-medium hover:bg-red-50 transition-colors"
                >
                    24/7 Emergency Line: +92 300 123 4567
                </a>
                </div>
            </div>
            
            {/* FAQ Section */}
            <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h2>
                
                <div className="space-y-4">
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    <h3 className="font-bold text-lg mb-2">What should I do if I've been arrested in Islamabad or Rawalpindi?</h3>
                    <p className="text-gray-600">
                    If you're arrested, remain silent and do not provide any statements without your lawyer present. 
                    You have the right to legal representation - exercise it immediately by contacting Wisdoms Law. 
                    Do not sign any documents until your attorney has reviewed them.
                    </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    <h3 className="font-bold text-lg mb-2">Can a false FIR filed against me in Rawalpindi or Islamabad be challenged?</h3>
                    <p className="text-gray-600">
                    Yes, false FIRs can be challenged through quashment proceedings. Our team can help you file the 
                    appropriate applications to have a false or incorrectly filed FIR set aside in any police station in the twin cities, 
                    preventing wrongful prosecution.
                    </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    <h3 className="font-bold text-lg mb-2">How soon can you arrange bail after an arrest in Islamabad or Rawalpindi?</h3>
                    <p className="text-gray-600">
                    Our emergency response team works quickly to arrange bail applications as soon as possible after an arrest. 
                    In many cases, we can file bail applications within hours in Islamabad and Rawalpindi courts, though the timeline for court hearings varies 
                    depending on the court's schedule and the nature of the charges.
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>
        
        {/* Whatsapp Float Button */}
        <div className="fixed bottom-6 right-6 z-50">
            <a 
            href="https://wa.me/923329754400" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg flex items-center justify-center w-16 h-16"
            >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
            </svg>
            </a>
        </div>
        </div>
    );
};

export default CriminalLawService;